import { css, SerializedStyles } from '@emotion/react';

export const useStyles = () => ({
  noPreviewWrapper: css({
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  }),
  noPreviewIcon: css({
    fontSize: "90px !important",
    width: "90px !important",
    height: "90px !important",
    color: "white !important",
    "& svg": {
      color: "white !important",
    },
  }),
  noPreviewContent: css({
    color: "white",
    textAlign: "center",
    marginTop: "10px",
    fontSize: "12px",
  }),
});
